






















































































import Vue from "vue";

export default Vue.extend({
  name: "RodoInformation",
  props: {
    isOpen: Boolean,
  },
  data() {
    return {
      TRANSLATION_KEY: "RodoInformation",
    };
  },
});
